import React, { useState, useEffect, useContext } from "react";
import OpenSeadragon from "openseadragon";
import { initOverlay, fabric  } from "openseadragon-fabricjs-overlay";
import * as Annotorious from '@recogito/annotorious-openseadragon';
import * as AnnotoriousSelectorPack from '@recogito/annotorious-selector-pack';

import '@recogito/annotorious-openseadragon/dist/annotorious.min.css';
import RubberbandPolygonTool from '../draw/tools/line/RubberbandLineTool';
import '../utils/openseadragon-scalebar';
import '../utils/openseadragonScreenshot';

import viewerContext from '../utils/viewerContext';

initOverlay(OpenSeadragon, fabric);
window.OpenSeadragon = OpenSeadragon

const config = {
  allowEmpty: true,
  // disableEditor: true,
  disableSelect: true,
  drawOnSingleClick: true
};

const viewportNavigator = {
  showNavigator: true,
  navigatorAutoFade: false,
  navigatorPosition: "BOTTOM_RIGHT",
  navigatorDisplayRegionColor: "#ccc"
}

const OpenSeaDragonViewer  = () => {
  const [viewer, setViewer] = useState(null);

  // context: 与rotationCircle进行交互
  const { 
    rotationDegree, setRotationDegree, annoHistory, updateAnnoInfo, removeAnno, image, setAnnotorious, annotorious,
    handleAddAnnotations, setZoomLive, maxZoomLive
  } = useContext(viewerContext);

  useEffect(() => {
    const ajaxOption = {
      // ajaxWithCredentials: process.env.NODE_ENV === "production"
      // 发现这一项就是不能为true
      ajaxWithCredentials: false
    }
    viewer && viewer.destroy();
    const initViewer = OpenSeadragon({
      id: image.id,
      prefixUrl: "//openseadragon.github.io/openseadragon/images/", // openseagragon 自带的图标
      blendTime: 0.5,                                               // 加载时长 过度动画
      autoHideControls: true,                                       // 没有操作时 缩略图自动隐藏
      showNavigator: true,                                          // 是否显示缩略图
      // maxZoomLevel: 2,
      immediateRender: false,                                       // 初始化渲染, 是否自动选择最佳分辨率图片显示
      // constrainDuringPan: true,
      // maxZoomPixelRatio: 2,                                         // 最大放大倍率，窗口的百分比
      // autoResize: true,                                             // 设置是否自动伸缩，若容器宽度放大或缩小，图片重新渲染
      // minZoomLevel: 0,
      // visibilityRatio: 1,
      // zoomPerClick: 2,                                              // 点击一下, 放大倍率; 设置为1,则代禁用单击事件  同gestureSettingsMouse.clickToZoom
      // zoomPerScroll: 2,                                             //滚轮放大倍率; 设置为1,则代表禁用滚轮事件   同gestureSettingsMouse.scrollToZoom
      toolbar: 'bar',
      zoomInButton: 'zoom-in',
      zoomOutButton: 'zoom-out',
      showRotationControl: true,
      showFlipControl: true,
      crossOriginPolicy: "Anonymous",
      ...ajaxOption, // 在开发模式下，开着这个参数结果是不对的；在cntest部署后也一样
      ...viewportNavigator
    });

    setViewer(initViewer);

    const annotate = Annotorious(initViewer, config);
    AnnotoriousSelectorPack(annotate, {
      // tools: ['multipolygon']
    });
    
    annotate.addDrawingTool(RubberbandPolygonTool);
    setAnnotorious(annotate);

    initViewer && initScale(initViewer, image.PPM?.x);
    initViewer && initViewer.open(image.url);
    initViewer && onInitViewerEvent(initViewer)
    initViewer && initRotation(initViewer);

    return () => {
      viewer && viewer.destroy();
    };
  }, [image, setRotationDegree]);

  useEffect(() => {
    if(viewer) {
      // viewer.viewport.maxZoomLevel = maxZoomLive;
      viewer.viewport.zoomTo(maxZoomLive)
    }
  }, [maxZoomLive, viewer])

  const onInitViewerEvent = ( initViewer ) => {
    initViewer.addHandler("zoom", (event) => {
      setZoomLive(Math.round(event.zoom * 10) / 10);
    })
  };

  useEffect(() => {
    if (annotorious) {
      annotorious.on('createAnnotation', (annotation) => {
        annotorious.setDrawingEnabled(true)
        handleAddAnnotations(annotation)
      });

      annotorious.on('updateAnnotation', (annotation, previous) => {
        updateAnnoInfo(annotation)
      });

      annotorious.on('deleteAnnotation', (annotation)=> {
        removeAnno(annotation)
      });

      annotorious.on('dblclick', (annotation)=> {
        // removeAnno(annotation)
        console.log(annotation)
        annotorious.selectAnnotation(annotation)
      });
    }
  }, [annotorious]);

  useEffect(() => {
    if (annotorious) {
      annotorious.setAnnotations(annoHistory);
    }
  }, [annotorious, annoHistory])

  useEffect(() => {
    viewer && viewer.viewport.setRotation(rotationDegree)
  }, [viewer, rotationDegree])

  // 初始化比例尺工具
  const initScale = (initViewer, PPMx) => {
    if(!PPMx){
      console.error("Cannot init scalebar because no PPMx.")
      return
    }
    console.log("PPMx:", PPMx)
    initViewer.scalebar({
      // 设置像素与实际的比值
      pixelsPerMeter: PPMx,  // AWS-273 PPM包括x和y，这里只用y
      minWidth: '150px',
      xOffset: 0,
      yOffset: 0,
      stayInsideImage: false,
      color: 'rgb(0, 0, 0)',
      fontColor: 'rgb(0, 0, 0)',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      fontSize: 'middle',
      barThickness: 4,
    });
  };

  // 注册到rotate事件，当Viewer发生rotate时，把状态传递给context
  const initRotation = (initViewer) => {
    window.viewer = initViewer
    initViewer.addHandler(
      'rotate',
      (e) => {
        const { degrees } = e
        // 通过这个函数将degrees的数据传递出去
        setRotationDegree(degrees)
      }
    )
    initViewer.viewport.setRotation(0)
  }

  return (
    <div className="h-full flex flex-col">
      <div id={image.id} className="flex-1 h-full"></div>

      <div id="layer-box"></div>
    </div>
  )
};

export default OpenSeaDragonViewer;